module.exports = __webpack_public_path__ + "static/media/the_loop2.85412b5e.png";